import { get, post, del, put } from '@/libs/api.request'

export const getQuoteItems = (quoteId, data) => {
  return get(`quotes/${quoteId}/items`, data)
}

export const createQuoteItem = (quoteId, data) => {
  return post(`quotes/${quoteId}/items`, data)
}

export const updateQuoteItem = (quoteId, itemId, data) => {
  return put(`quotes/${quoteId}/items/${itemId}`, data)
}

export const deleteQuoteItem = (quoteId, itemId) => {
  return del(`quotes/${quoteId}/items/${itemId}`)
}

// derepcated
export const tryToPopulateQuoteItems = (quoteId) => {
  return post(`quotes/${quoteId}/populate-items`)
}

export const sendQuoteItemsToHubSpot = (quoteId) => {
  return post(`quotes/${quoteId}/sync-items-to-hubspot`)
}
